import type { ChipVariantKey } from "@imminently/decisively-ui/Chip";

import type { AdapterStatusState } from "@/features/adapters/model";

export const stateVariant: Record<AdapterStatusState, ChipVariantKey> = {
  ready: "success",
  missing: "warning",
  incomplete: "warning",
  conflict: "destructive",
  error: "destructive",
};

export const statusLabel = (value: AdapterStatusState): string => ({
  ready: "Ready",
  missing: "Needs setup",
  incomplete: "Needs setup",
  conflict: "Conflict",
  // Unfinished and broken setup read the same; the colour tells them apart.
  error: "Needs setup",
})[value];
